<!--
================================================
Un composant contenant les différents filtres de la report view

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary

DÉTAIL :
    * Le paramètre de route : 'pjctArchShow' permet d'afficher les projets selon isArchived (all/active/archived)

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="FiltersComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <div id="toggleFilters" class="is-hidden-desktop" v-on:click="toggleFiltersVisibility()">

        <span v-if="!visibility" class="showFilters">
          <font-awesome-icon class="icon" :icon="['fas', 'filter']"/>
          {{$t('voirLesFiltres')}}
        </span>
        <span v-else class="hideFilters is-hidden-desktop">
          <font-awesome-icon class="icon" :icon="['fas', 'filter']"/>
          {{$t('masquerLesFiltres')}}
        </span>

      </div>

      <!-- showFiltersDesktop sert à pouvoir ré-afficher les filtres dans le cas où il sont été masqué en vue mobile puis que la page a étée redimensionnée en desktop  -->
      <span v-if="!visibility" class="showFiltersDesktop is-hidden-touch " v-on:click="visibility=true">
          <font-awesome-icon class="icon" :icon="['fas', 'filter']"/>
          {{$t('voirLesFiltres')}}
        </span>

        <div class="columns filtersCont" v-show="visibility">


            <div class="column filterInit">
              <font-awesome-icon class="icon" :icon="['fas', 'search']"/>
              <a class="reinitLInk" v-on:click="reinitFilters()" v-if="filterCountTotal>=1">{{$t('réinitialiser')}}</a>
              <span class="text" v-else>{{$t('filtrer')}}</span>
              <span class="bracket">}</span>
            </div>


            <!-- taskName filter ------------------------------>
          <div class="column ">
            <task-name-filter-comp></task-name-filter-comp>
          </div>

            <!-- client filter ------------------------------>
            <div class="column">
              <client-filter-comp></client-filter-comp>
            </div>

            <!-- project filter ------------------------------>
            <div class="column">
              <project-filter-comp></project-filter-comp>
            </div>

            <!-- billable filter ------------------------------>
            <div class="column">
              <billable-filter-comp></billable-filter-comp>
            </div>

            <!-- tag filter ------------------------------>
            <div class="column">
              <tag-filter-comp></tag-filter-comp>
            </div>


        </div>
    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import ProjectFilterComp from "./ProjectFilterComp";
    import ClientFilterComp from "./ClientFilterComp";
    import BillableFilterComp from "./BillableFilterComp";
    // import SentryMixin from "../../mixins/SentryMixin";
    // import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    // import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    import _ from "lodash";
    import TaskNameFilterComp from "@/components/Reports/TaskNameFilterComp";
    import TagFilterComp from "@/components/Reports/TagFilterComp";

    export default {
        name: 'FiltersComp',
        components: {TagFilterComp, TaskNameFilterComp, ProjectFilterComp,ClientFilterComp,BillableFilterComp},
        //utile dans vue dev tool
        mixins: [
            // SentryMixin, InterceptorMixin
        ],
        data: function () {
            return {
                filterCount : { // Un objet contenant les compteurs de filtre pour les sous composant filtres
                    project: 0, // int le nombre de projet filtrés dans le ProjectFilterComp
                    client: 0,// int le nombre de client filtrés dans le ClientFilterComp
                    billable: 0, // int le nombre de client filtrés dans le BillableFilterComp
                    taskName: 0, // int le nombre de critère de filtre dans taskNameFilterComp
                    tag: 0 // int le nombre de critère de filtre dans TagFilterComp

                },
                visibility: true // bool si true les filtres sont affichés dans l'UI
            }
        },

        computed: {
            // computed props for store :
            ...mapState({
                // currentPeriod: state => state.ReportView.currentPeriod
              themeToDisplay: state => state.app.themeToDisplay
            }),

            //----------------------------------------------

            // other computed props :

            // Le total de tous les compteurs de this.filterCount
            filterCountTotal: {
                get: function () {
                    // on itère sur toutes les prop de l'objet filterCount et on compte
                    let total = 0;
                    _.forOwn(this.filterCount, function(value) {
                        total = total + value
                    });
                    return total
                },
            }

        },
        watch: {},


        methods: {
            /*
                Envoie un event 'reinit_filters' qui réinitialisera les filtes dans les composants enfant
             */
            reinitFilters(){
                this.$root.$emit('reinit_filters') // pour notifier le ProjectFilterCompt

                // on remet tous les compteurs à 0 dans filterCount
                let reset = {}
                _.forOwn(this.filterCount, function(value, key) {
                    reset[key] = 0;
                });
                this.filterCount = reset
            },

          /**
           * Affiche/masque les filtres (Utilisé sur touch car les filtres prennent beaucoup de place dans l'UI
           **/
            toggleFiltersVisibility(){
              if(this.visibility == true){
                this.visibility=false
              }
              else{
                this.visibility=true
              }

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

          // maj de filterCount.project quand le nombre d'éléments filtrés change dans FilterProjectComp
          this.$root.$on('filter_project_count_update', (count) => {
            this.filterCount.project = count
          })
          this.$root.$on('filter_client_count_update', (count) => {
            this.filterCount.client = count
          })
          this.$root.$on('filter_taskname_count_update', (count) => {
            this.filterCount.taskName = count
          })
          this.$root.$on('filter_billable_count_update', (count) => {
            this.filterCount.billable = count
          })
          this.$root.$on('filter_tag_count_update', (count) => {
            this.filterCount.tag = count
          })

          // sur mobile par défaut on masque les filtres
          if (this.$mq === 'mobile') {
            this.visibility=false;
          }

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    @import "../../assets/css/bulmaResponsiveDep.scss";

    #FiltersComp {
        /*border: dashed 1px deeppink;*/

      #toggleFilters {
        margin: .4rem auto 0;
        display: block;
        padding: .4rem 0;
        font-size: .9rem;
        .icon{
          vertical-align: bottom;
        }
      }

        .filtersCont{
          //border: solid 1px deeppink;
          @include touch{
            margin-top: 1rem; // sert à décaler les filtres du #toggleFilters sur touch
          }


        }
        .column {
            /*border: white dashed 1px;*/
            /*margin:  0 !important;*/
            padding: 0 !important;
        }

        .filterInit {
            a{
                vertical-align: middle;
            }
            .text {
                /*font-size: 1rem;*/
                line-height: 1rem;
                display: inline-block;

            }

            .icon {
                color: $brandBlue;
                margin-right: 0.5rem;
                font-size: 0.9rem;
                vertical-align: middle;
            }

            .bracket {
                color: $brandBlue;
                font-size: 2rem;
                margin-left: 0.5rem;
                vertical-align: middle;

            }
        }


        //////////////////////////////////////
        // DARK UI ///////////////////////////
        &.darkMode {

          #toggleFilters {
            color:$darkTxt;
          }
          .filterInit {
            .text{color:$darkLightBlue;}
            .icon {color: $darkLightBlue;}
            .bracket {color: $darkLightBlue;}
          }

          .showFiltersDesktop {
            color:$darkTxt;
            cursor:pointer
          }

        }
      }

</style>

<style lang="scss">
    @import "../../assets/css/globalVar.scss";
    @import "../../assets/css/bulmaResponsiveDep.scss";

    // ATTENTION CSS NON SCOPÉS

    // styles des composants filter
    .selector {
        $height: 3rem;
        height: $height;
        background: white;
        line-height: $height;
        margin: 0 .5rem 0 0;
        border-radius: 2px;
        vertical-align: middle;
        position: relative;
        font-size: .9rem;
        z-index: 1; // évite que le contenu des TimerecordReportTableLineComp ne passe pas par dessus .selector
        @include mobile {
            margin-bottom: 0.5rem;
            height: auto;
        }

        .opener{
            cursor: pointer;
            .text{
                text-transform: capitalize;

              // limitation de la longeur d'affichage
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              @include mobile{
                line-height:2rem;
                vertical-align: middle;
              }
              @include tablet{
                //color: yellow;
              }
              @include desktop{
                max-width: 3rem;
                //color: red;
              }
              @include widescreen{
                max-width: 4rem;
                //color: orange;
              }

              @include fullhd{
                max-width: 10rem;
                //color: greenyellow;
              }
            }
        }
        .iconType {
            margin: 0.7rem 0.3rem 0 1rem;

        }
        .icon{

          @include mobile{
            display: inline-block;
          }

          @include desktop {
            display: inline-block;
          }
          @include tablet {
            display: inline-block;
          }

          @include widescreen{
            display: inline-block;
          }

        }
        .icon.chevron {
          margin: .8rem .8rem 0 0;
          @include tablet {display: none;}
          @include desktop {display: none;}
          @include widescreen {display: none;}
          @include fullhd {display: inline-block;}
        }

        .text {
            /*vertical-align: top;*/
            /*text-align: left;*/

        }

        .loaderZone{

            margin-bottom: 0;

            .txt{
                font-size: 0.9rem;
                color: $brandThird
            }
        }

        .list {
            background-color: #fff;
            box-shadow: 0 2px 3px #ddd;
            border: solid 1px #ccc;

            margin-top: -1rem;
            border-radius: 0;

          @include mobile {
            margin-top: 1px;
          }

            .filterContent {
                /*border: solid 1px deeppink;*/
                max-height: 50vh;
                overflow: auto;

                .noRelatedEntries {
                    border-top: solid 1px #ddd;
                    border-bottom: solid 1px #ddd;

                }
                .quickSelect{

                }
                h3{
                    font-weight: bold;
                    text-transform: capitalize;
                }

                li {
                /*border-bottom: solid 1px #eee;*/
                text-align: left;
                padding:0 1rem;
                font-size: 0.9rem;
                /*margin-left: 1rem;*/


                label.checkbox {
                    input {
                        margin: 0 0.5rem 0 0;
                        text-align: left;
                    }
                    .icon{
                        vertical-align: middle;
                    }

                    &:hover {
                        color: $brandBlue;
                        transition: color 200ms ease-out;
                    }

                }
              }
            }

            .additionalFilter {
                background: #f4f4f4;
                color: $brandFourth;
                padding: 1rem ;
                font-size: 0.9rem;
                line-height: 1.6rem;

                span {
                    font-weight: bold;
                    /*margin-right: 0.5rem;*/
                }

                a {
                    color: $brandFourth;

                    &.activeLInk {
                        color: $brandBlue;
                        font-weight: bold;
                    }
                }

            }
        }

        .count {
            $size: 1.7rem;
            background: $brandBlue;
            color: white;
            font-weight: bold;
            height: $size;
            width: $size;
            line-height: $size;
            border-radius: $size;
            font-size: 0.9rem;
            position: absolute;
            right: -0.4rem;
            top: -0.4rem
        }


    }

    //////////////////////////////////////
    // DARK UI ///////////////////////////
    .darkMode { // @todo voir  ATTENTION ICI SYNTAX DIFFÉRENTE SANS LE "&" NE PAS REPRODUIRE
      //.columnAppContent{
      //  background: $darkBg;
      //}
      .selector{

        background-color: $darkFiltersBg !important;
        //color:$darkContrastTxt;
      }
      .opener{
        color:$darkContrastTxt;
        .icon{color: $darkLightBlue}
      }
      .list{
        background-color:lighten($darkBg2,5%) ;
        border-color: $darkTableBorder;
        box-shadow: 0 3px 5px #222;
        color:$darkTxt;
        .filterContent {
          .noRelatedEntries {
            border-top-color:  #666;
            border-bottom-color: #666;

          }

          .quickSelect,.quickSelect a{
            color:$darkLightBlue;

          }

        }

        .additionalFilter{
          background-color: $darkBg2;
          a {
            color: $darkBrandBlue !important;
            &.activeLInk {
              color: $darkTxt !important;
            }
          }
        }
      }
      //.count{color:$darkLightBlue}

    }



</style>
